module.exports = __webpack_public_path__ + "static/media/arrow.fd9b1ca0.svg";